import JoditEditor from "jodit-react";

import { useNavigate } from "react-router-dom";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import Title from "../../../Title/Title";
import Input from "../../../Inputs/Input";
import MainButton from "../../../Buttons/MainButton";
import { usePOST } from "../../../../ApiS";
import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { AxiosError } from "axios";

type Error = {
  title_ar?: string[];
  title_en?: string[];
  description_ar?: string[];
  description_en?: string[];
};

export default function AddProgramRules() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<Error>({});
  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };
  const { handleChangeInput, handleSubmit, setFormData, formData, mutation } =
    usePOST(
      {},
      () => {
        navigate("/infomation_application/program_role");
      },
      (error) => {
        onError(error);
      }
    );
  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  const handleSubmitWithValidation = () => {
    const requiredFields = ["title_ar", "title_en", "description_ar", "description_en"];
    const newErrors: Error = {};
  
    requiredFields.forEach((field) => {
      if (!formData[field as keyof typeof formData]) {
        newErrors[field as keyof Error] = [`${field} is required`];
      }
    });
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return;
    }
  
    handleSubmit("admin/program-rules");
  };

  return (
    <>
    <ToastContainer position="bottom-left"/>
      <Row>
        <Title title="اضافة قواعد البرنامج" />
      </Row>

      <Row justify={"center"} className="!mt-8 ">
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة العربية
          </h1>

          <Input name="title_ar" onChange={handleChangeInput} />

          {errors?.title_ar &&
            errors?.title_ar.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة الانكليزية
          </h1>

          <Input name="title_en" onChange={handleChangeInput} />
          {errors?.title_en &&
            errors?.title_en.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف الوصف باللغة العربية
          </h1>

          <JoditEditor
            value=""
            onChange={(e) => setFormData({ ...formData, description_ar: e })}
          />

          {errors?.description_ar &&
            errors?.description_ar.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة الانكليزية
          </h1>

          <JoditEditor
            value=""
            onChange={(e) => setFormData({ ...formData, description_en: e })}
          />
          {errors?.description_en &&
            errors?.description_en.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
      </Row>

      <Col className="flex justify-evenly !mt-4 ">
        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="اضافة"
            className="w-full"
            onClick={() =>handleSubmitWithValidation() }
          />
        </Col>

        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="الغاء"
            className="w-full !bg-gray-200 !text-Secondary"
            onClick={() => navigate(-1)}
          />
        </Col>
      </Col>
    </>
  );
}
